<template>
  <div class="app-page-sidebar" :style="{ '--app-sidebar-w': sidebarWidth }">
    <slot />
  </div>
</template>

<script>
/**
 * Page content wrapper for layouts that have a left sidebar.
 *
 * Same equal-4-edge padding contract as <app-page>, plus it reserves the left
 * column for the (absolutely-positioned) global sidebar so content never sits
 * under it. On narrow viewports the sidebar collapses into a slide-in drawer,
 * so the reserved column is dropped and content spans full width.
 *
 * Content-only: it does NOT render the sidebar itself (that's <c-sidebar>) —
 * place this as a sibling of the sidebar around the page content.
 *
 * The sidebar width is exposed as a CSS custom property so the responsive
 * media query can override the offset (inline styles can't be beaten by a
 * media query, a plain custom property can).
 */
export default {
  name: 'AppPageSidebar',

  props: {
    // Width of the sidebar to reserve space for. Any CSS length; defaults to
    // the global <c-sidebar> width (216px).
    sidebarWidth: {
      type: String,
      default: '216px',
    },
  },
}
</script>

<style scoped lang="scss">
// Self-contained tokens — mirrors the admin $ad-* spacing/breakpoints without
// importing the dashboard theme module.
$app-pad:      24px;
$app-pad-sm:   16px;
$app-bp-sm:    768px;   // padding tightens here
$app-bp-drawer: 1023px; // sidebar becomes an overlay drawer here (c-sidebar)

.app-page-sidebar {
  box-sizing: border-box;
  width: 100%;
  padding: $app-pad;
  // Reserve the fixed sidebar column; the padding above still applies inside.
  margin-left: var(--app-sidebar-w, 216px);
}

// Sidebar collapses to a drawer — reclaim the full width.
@media (max-width: $app-bp-drawer) {
  .app-page-sidebar {
    margin-left: 0;
  }
}

@media (max-width: $app-bp-sm) {
  .app-page-sidebar {
    padding: $app-pad-sm;
  }
}
</style>
